// TermeniComponent.jsx — FULL (unique classes + same design language)
import React, { useEffect, useState } from "react";
import api from "../../api/http";
import "../../styles/about/TermeniComponent.css";

const TermeniComponent = () => {
  const [termeni, setTermeni] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    let cancelled = false;

    const fetchTermeni = async () => {
      setLoading(true);
      setErrMsg("");

      try {
        const res = await api.get("/about/terminii/");
        const data = res.data;

        const list = Array.isArray(data)
          ? data
          : Array.isArray(data?.results)
          ? data.results
          : [];

        if (!cancelled) setTermeni(list);
      } catch (error) {
        if (!cancelled) {
          setErrMsg(error?.response?.data?.detail || error?.message || "Eroare la încărcare");
          setTermeni([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchTermeni();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="srTerms_page">
      <div className="srTerms_wrap">
        <div className="srTerms_card">
          <div className="srTerms_header">
            <h2 className="srTerms_title">Termeni și condiții</h2>
            <p className="srTerms_subtitle">Informații utile pentru închiriere</p>
          </div>

          {loading && <p className="srTerms_state">Se încarcă...</p>}
          {!loading && errMsg && <p className="srTerms_state srTerms_stateErr">{errMsg}</p>}

          {!loading && !errMsg && (
            <ul className="srTerms_list">
              {termeni.map((termen) => (
                <li key={termen.id} className="srTerms_item">
                  <h3 className="srTerms_itemTitle">* {termen.titlu}</h3>

                  {termen.descrierea && <p className="srTerms_text">{termen.descrierea}</p>}
                  {termen.text && <p className="srTerms_text2">{termen.text}</p>}
                </li>
              ))}

              <li className="srTerms_notice">
                <strong>*</strong> <strong>SupremeRentals</strong> își rezervă dreptul de a nu
                oferi automobil în chirie unor persoane, fără a da careva explicații!
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default TermeniComponent;